import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

export interface CaseFilterType {
  searchCase?: string;
  processingClass?: string;
  processingSubClass?: string;
  caseStatus?: string;
  caseManager?: string;
  pageNumber?: number;
  pageSize?: number;
  sortField?: string;
  sortDirection?: string;
}

export enum CaseFilterKeys {
  SearchCase = 'searchCase',
  ProcessingClass = 'processingClass',
  ProcessingSubClass = 'processingSubClass',
  CaseStatus = 'caseStatus',
  CaseManager = 'caseManager',
  PageNumber = 'pageNumber',
  PageSize = 'pageSize',
  SortField = 'sortField',
  SortDirection = 'sortDirection'
}

@Injectable({
  providedIn: 'root'
})
export class CaseFilterCacheService {
  private filterValues: CaseFilterType = {};
  private readonly cachedFilterValues: BehaviorSubject<CaseFilterType> = new BehaviorSubject<CaseFilterType>(null);

  constructor() {
  }

  saveFilterValue(key: string, value: string | number): void {
    this.filterValues[key] = value;
    this.cachedFilterValues.next(this.filterValues);
  }

  saveMultipleFilterValue(values: any): void {
    this.filterValues = {...this.filterValues, ...values};
    this.cachedFilterValues.next(this.filterValues);
  }

  // Get the cached value for a specific key
  getFilterValue(): Observable<CaseFilterType> {
    return this.cachedFilterValues.asObservable();
  }

  // Clear the cached value for a specific key
  clearFilterValue(key: string): void {
    this.filterValues[key] = '';
    this.cachedFilterValues.next(this.filterValues);
  }
}
